export default {"src":"/_next/static/media/emg-icon.49835149.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};